
<template>
  <component
    :is="tag"
    :class="{...buttonClasses, ...classes}"
    v-bind="$attrs"
    v-on="$listeners">
    <i v-if="icon" class="material-icons" aria-hidden="true">{{ icon }}</i>
    <span v-if="!iconOnly">
      <slot />
    </span>
  </component>
</template>

<script>
import buttonMixin from '@/mixins/button';

export default {
  name: "TrekLink",
  inheritAttrs: false,
  mixins: [buttonMixin],
  props: {
    button: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        "button--disabled": this.button && this.disabled,
        "underline hover:no-underline": !this.button && this.underline,
      }
    },
    tag() {
      return this.disabled ? 'span' : 'a'
    }
  }
};

</script>
